import React from 'react';
import {
  string, bool, object, arrayOf
} from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { Row, Col } from '@thd-olt-component-react/grid';
import classNames from 'classnames/bind';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import styles from '../dynamic-broad-intent-aisle.module.scss';

export const ProductGrid = ({
  title, products, isMobile, storeId, shopAllUrl, categoryKey
}) => {
  const cx = classNames.bind(styles);
  const shopLink = isMobile ? `Shop ${title}` : `Shop All ${title}`;
  let mobileDpd = [];
  let dpd = [];
  mobileDpd.push(products[0]);
  dpd = isMobile ? mobileDpd : products;

  let colLength = 6;
  if ([3, 4, 5, 6].indexOf(dpd.length) > -1) {
    colLength = 7 - dpd.length;
  }
  if (isMobile) colLength = 12;

  return (
    <>
      <Row className={cx('dynamic-broad-intent-aisle__product-card')}>
        <Row className={cx('dynamic-broad-intent-aisle__product-card-header')}>
          <Col xs="12" className={cx('dynamic-broad-intent-aisle__col-no-padding')}>
            <h2>{title}</h2>
          </Col>
        </Row>
        <Row>
          {dpd.map((product) => {
            if (typeof product === 'undefined') return null;
            return (
              <Col
                xs={colLength}
                fallback={colLength}
                key={product.itemId}
                className={cx('dynamic-broad-intent-aisle__product-column')}
              >
                <ProductPod
                  itemId={product.itemId}
                  storeId={storeId}
                  hideShippingInfo
                  hideFulfillment
                  hideStoreInfo
                  hideATC
                  hidePriceBadge
                  hideShopThisCollection
                  hideLimitPerOrder
                  hideSavingsText
                  swatchCount={1}
                  hideFavorites
                  hideSeeSimilarItems
                />
              </Col>
            );
          })}
          <Col
            xs="12"
            key={`${categoryKey}_shopAllLink`}
            className={cx('dynamic-broad-intent-aisle__shop-all-link')}
          >
            <div className={cx('dynamic-broad-intent-aisle__link-container')}>
              <a href={shopAllUrl}>{shopLink}</a>
            </div>
          </Col>
        </Row>
      </Row>
    </>
  );
};

ProductGrid.displayName = 'ProductGrid';
ProductGrid.dataModel = extend({}, ProductPod);
ProductGrid.propTypes = {
  storeId: string.isRequired,
  title: string.isRequired,
  isMobile: bool,
  // eslint-disable-next-line react/forbid-prop-types
  products: arrayOf(object).isRequired,
  shopAllUrl: string.isRequired,
  categoryKey: string
};

ProductGrid.defaultProps = {
  isMobile: false,
  categoryKey: ''
};
